import React from "react";
import styled from "styled-components";

export const Wrapper = styled.div`
  margin-bottom: 5px;
  display: flex;
  justify-content: flex-end;
`;

export const HelpIcon = styled.em`
  font-size: 22px;
  color: #999;
  cursor: pointer;

  &:hover {
    color: #333;
  }
`;

const Icon = ({ toggle }) => {
  return (
    <Wrapper className="sp-help-info" onClick={toggle}>
      <HelpIcon className="far fa-question-circle" />
    </Wrapper>
  );
};

export default Icon;
